import { useState, createContext, useContext } from 'react'
import { IconCheck, IconAlertTriangle, IconInfoCircle, IconX } from '@tabler/icons-react'

const ToastContext = createContext(null);

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be inside ToastProvider');
  return ctx;
}

const ICONS = {
  success: <IconCheck size={20} />,
  error:   <IconAlertTriangle size={20} />,
  warning: <IconAlertTriangle size={20} />,
  info:    <IconInfoCircle size={20} />
}

const VARIANT_CLASS = {
  success: 'tg-toast--success',
  error:   'tg-toast--danger',
  warning: 'tg-toast--warning',
  info:    'tg-toast--info'
}

function ToastItem({ toast, onDismiss }) {
  return (
    <div className={`tg-toast ${VARIANT_CLASS[toast.type] || ''}`} style={{ animation: 'tg-toast-in 0.18s ease-out' }}>
      <div className="tg-toast__icon">{ICONS[toast.type]}</div>
      <div className="tg-toast__body">
        <div className="tg-toast__title">{toast.message}</div>
      </div>
      <button className="tg-toast__close" onClick={() => onDismiss(toast.id)} aria-label="Dismiss">
        <IconX size={16} />
      </button>
    </div>
  )
}

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);

  function show(message, type = 'success') {
    const id = Date.now() + Math.random();
    setToasts(t => [...t, { id, message, type }]);
    setTimeout(() => setToasts(t => t.filter(x => x.id !== id)), 4000);
  }

  function dismiss(id) {
    setToasts(t => t.filter(x => x.id !== id));
  }

  const toast = {
    success: msg => show(msg, 'success'),
    error:   msg => show(msg, 'error'),
    warning: msg => show(msg, 'warning'),
    info:    msg => show(msg, 'info')
  };

  return (
    <ToastContext.Provider value={toast}>
      {children}
      <div style={{
        position: 'fixed', top: 64, right: 18,
        zIndex: 'var(--tg-z-toast)',
        display: 'flex', flexDirection: 'column', gap: 8,
        pointerEvents: 'none'
      }}>
        {toasts.map(t => (
          <div key={t.id} style={{ pointerEvents: 'auto' }}>
            <ToastItem toast={t} onDismiss={dismiss} />
          </div>
        ))}
      </div>
      <style>{`@keyframes tg-toast-in { from { transform: translateX(20px); opacity: 0; } to { transform: translateX(0); opacity: 1; } }`}</style>
    </ToastContext.Provider>
  );
}
